<template>
  <div>        
    <div>
        <div class="p-fluid p-formgrid p-grid">
            <div class="p-field p-col-12 p-md-6">
                <label>Empresa</label>
                <Dropdown v-model.number="idCnpjSelecionado" :options="cnpjs" optionLabel="cnpjNome" optionValue="id" placeholder="Selecione"
                    @change="listarCentrosCustos"/>
            </div>
                <div class="p-field p-col-12 p-md-6">
                <label>Centro de custo</label>
                <Dropdown v-model.number="idCentroCustoSelecionado" :options="centrosCustos" optionLabel="nome" optionValue="id" placeholder="Todos"
                    dataKey="keyRefId" :filter="true" :showClear="true"/>
            </div>                               
        </div> 
        <div class="p-fluid p-formgrid p-grid">
            <div class="p-field p-col-12 p-md-3">
                <label>Data início</label>
                <Calendar v-model="dataInicio" :showIcon="true" :manualInput="false" dateFormat="dd/mm/yy" :locale="localeCalendarBR"/>				
            </div>
            <div class="p-field p-col-12 p-md-3">
                <label>Data final</label>
                <Calendar v-model="dataFinal" :showIcon="true" :manualInput="false" dateFormat="dd/mm/yy" :locale="localeCalendarBR"/>	
            </div>
            <div class="p-field p-col-0">
                <label style="color:#ffffff">.</label>  
                <Button label="Buscar" icon="pi pi-search" @click="listar"/>
            </div> 
        </div>
        <DataTable :value="horarios" :filters="filtro" :paginator="true" :rows="10"
            paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
            :rowsPerPageOptions="[10,15,20]" currentPageReportTemplate="Listando {first} a {last} de {totalRecords}"
            class="p-datatable-sm p-datatable-striped">
            <template #header>
                <div class="table-header">	
                    <div class="p-d-flex p-jc-end">			
                        <span class="p-input-icon-left">
                            <i class="pi pi-search" />
                            <InputText v-model="filtro['global']" placeholder="Filtrar..." />
                        </span>
                    </div>
                </div>
            </template>
            <Column field="crachaFuncionario" header="Crachá" sortable></Column>
            <Column field="nomeFuncionario" header="Nome" sortable></Column>
            <Column field="justificativa" header="Justificativa" sortable></Column>
            <Column field="dia" header="Data" sortable>
                <template #body="slotProps">
                    {{ formatarStringData(slotProps.data.dia) }}
                </template>
            </Column>   
            <Column>
                <template #body="slotProps">
                    <Button icon="pi pi-pencil" title="Editar" class="p-button-rounded p-button-primary p-mr-2" @click="editar(slotProps.data)" v-if="permissaoEditar"/>
                    <Button icon="pi pi-trash" title="Excluir" class="p-button-rounded p-button-danger" @click="confirmarExcluir(slotProps.data)" v-if="permissaoExcluir"/>							
                </template>
            </Column>         
        </DataTable> 

        <Dialog :visible.sync="exibirDialogEditar" header="Editar Mudança de Horário" :modal="true" class="p-fluid" :style="{width: '600px'}">			
            <div class="p-fluid p-formgrid p-grid">
                <div class="p-field p-col-12 p-md-12">
                    <label>Funcionário</label>
                    <InputText v-model="funcionario.nome" readonly/>
                </div>                      
            </div>
            <div class="p-fluid p-formgrid p-grid">
                <div class="p-field p-col-12 p-md-12">
                    <label>Justificativa</label>
                    <Dropdown v-model.number="idJustificativaSelecionada" :options="justificativas" optionLabel="descricao" 
                        optionValue="id" dataKey="id" :filter="true" placeholder="Selecione" appendTo="body"/>
                </div>                      
            </div>
            <label>Horário</label>
            <div class="p-fluid p-formgrid p-grid p-mt-2">
                <div class="p-field p-col">
                    <label>1ª Entrada</label>
                    <InputText v-model="horarioFlexivelEditar.entrada1" maxlength="5" placeholder=":" class="p-text-center" 
                    @keyup="validarEntraHora" @focusout="limparEntradaHoraInvalida('entrada1')"/>				
                </div>
                <div class="p-field p-col">
                    <label>1ª Saída</label>
                    <InputText v-model="horarioFlexivelEditar.saida1" maxlength="5" placeholder=":" class="p-text-center" 
                    @keyup="validarEntraHora" @focusout="limparEntradaHoraInvalida('saida1')"/>		
                </div>
                <div class="p-field p-col">
                    <label>2ª Entrada</label>
                    <InputText v-model="horarioFlexivelEditar.entrada2" maxlength="5" placeholder=":" class="p-text-center" 
                    @keyup="validarEntraHora" @focusout="limparEntradaHoraInvalida('entrada2')"/>		
                </div>
                <div class="p-field p-col">
                    <label>2ª Saída</label>
                    <InputText v-model="horarioFlexivelEditar.saida2" maxlength="5" placeholder=":" class="p-text-center" 
                    @keyup="validarEntraHora" @focusout="limparEntradaHoraInvalida('saida2')"/>		
                </div>
                <div class="p-field p-col">
                    <label>3ª Entrada</label>
                    <InputText v-model="horarioFlexivelEditar.entrada3" maxlength="5" placeholder=":" class="p-text-center" 
                    @keyup="validarEntraHora" @focusout="limparEntradaHoraInvalida('entrada3')"/>		
                </div>
                <div class="p-field p-col">
                    <label>3ª Saída</label>
                    <InputText v-model="horarioFlexivelEditar.saida3" maxlength="5" placeholder=":" class="p-text-center" 
                    @keyup="validarEntraHora" @focusout="limparEntradaHoraInvalida('saida3')"/>		
                </div>  
            </div>             
            <div class="p-fluid p-formgrid p-grid">
                <div class="p-field p-col-12 p-md-12">
                    <label>Dia</label>                    
                    <InputText v-model="horarioFlexivelEditar.dia" readonly/>	
                </div>              
            </div>				
            <template #footer>
                <Button label="Cancelar" icon="pi pi-times" class="p-button-secondary" @click="fecharModal"/>
                <Button label="Salvar" icon="pi pi-check" @click="salvar"/>
            </template>
        </Dialog>

        <Dialog :visible.sync="exibirDialogConfirmarExcluir" header="Confirmar" :modal="true" :style="{width: '450px'}">
            <div class="confirmation-content">
                <i class="pi pi-exclamation-triangle p-mr-3" style="font-size: 2rem; color:red" />
                <span>Excluir mudança de horário?</span>
                <p>
                    <br/>
                    Funcionário: <b>{{ horarioFlexivelSelecionado.nomeFuncionario }}</b><br/>
                    Justificativa: <b>{{ horarioFlexivelSelecionado.justificativa }}</b><br/>
                    Data: <b>{{ horarioFlexivelSelecionado.dia }}</b>
                </p>
            </div>
            <template #footer>
                <Button label="Não" icon="pi pi-times" class="p-button-secondary" @click="limparExcluir"/>
                <Button label="Sim" icon="pi pi-check" class="p-button-danger" @click="excluir" />
            </template>
        </Dialog>

    </div>
  </div>
</template>

<script>
import CentroCustoService from '@/service/CentroCustoService';
import MudancaHorarioService from '@/service/MudancaHorarioService';
import ControlePontoService from '@/service/ControlePontoService.js';
import HorarioFlexivel from '@/model/HorarioFlexivel';
import CentroCusto from '@/model/CentroCusto';
import { exibirMensagem, exibirMensagemSis, formatarEtradaHora, localeCalendarBR } from '@/global';
import { mapGetters } from 'vuex';

export default {
    controlePontoService: null,
    mudancaHorarioService: null,    
    centroCustoService: null,
    data() {
        return {
            exibirDialogConfirmarExcluir: false,
            exibirDialogEditar: false,           
            horarioFlexivelSelecionado: {id: null, nomeFuncionario: '', data: null},           
            horarioFlexivelEditar: new HorarioFlexivel(),
            idJustificativaSelecionada: null,
            justificativas: [],
            funcionario: {nome: ''},
            permissaoEditar: false,
			permissaoExcluir: false,
            idCentroCustoSelecionado: null,
            idCnpjSelecionado: null,
            cnpjs: [],
            centrosCustos: [],
            dataInicio: new Date(),
            dataFinal: new Date(),           
            horarios: [],
            filtro: {},
            localeCalendarBR: localeCalendarBR
        }
    },
    methods: {
        ...mapGetters('sessao', ['getDadosRequisicao','getPermissoes', 'getCacheEmpresa']),
        /**
         * 
         */
        salvar() {
            let cnpjSelecionado = null;
            this.cnpjs.forEach(cnpj => {
                if(this.idCnpjSelecionado == cnpj.id) {
                    cnpjSelecionado = cnpj;
                }
            });
            let justificativa = null;
            for(let i =0; i < this.justificativas.length; i++) {
                if(this.idJustificativaSelecionada == this.justificativas[i].id) {
                    justificativa = {...this.justificativas[i]};
                    break;
                }
            }
            let hrFlex = {...this.horarioFlexivelEditar};
            hrFlex.dia = this.formatarData(this.horarioFlexivelEditar.dia);
            let requisicao = {  
                horarioFlexivel: hrFlex,
                cnpj: cnpjSelecionado,
                funcionario: {
                    id: this.funcionario.id,
                    nome: this.funcionario.nome,
                    pis: this.funcionario.pis
                },              
                justificativa: justificativa, 
                usuarioRequisicao: {...this.getDadosRequisicao()}
            };
            this.mudancaHorarioService.alterar(requisicao)
            .then(resp => {                    
                if(resp.data instanceof Array) {
                    exibirMensagemSis(this, 'Sucesso', false);     
                } else {
                    exibirMensagem(this, resp);   
                } 
                this.fecharModal();
                this.listar();
                if(resp.data instanceof Array && resp.data.length > 0) {
                    let novaRequisicao = {
                        mes: resp.data[0].mes,
                        ano: resp.data[0].ano,
                        dataInicio: resp.data[0].dataInicio,
                        dataFinal: resp.data[0].dataFinal,
                        cnpj: cnpjSelecionado,
                        funcionario:  {
                            id: requisicao.funcionario.id,
                            nome: requisicao.funcionario.nome,
                            pis: requisicao.funcionario.pis
                        },      
                        usuarioRequisicao: {...this.getDadosRequisicao()},          
                    };
                    this.calcularPeriodoEditado(novaRequisicao);
                }
            })
            .catch(erro => {exibirMensagem(this, erro)}); 
        },
        /**
         * 
         */
        excluir() {
            let cnpjSelecionado = null;
            this.cnpjs.forEach(cnpj => {
                if(this.idCnpjSelecionado == cnpj.id) {
                    cnpjSelecionado = cnpj;
                }
            });
            let funcionario = {
                nome: this.horarioFlexivelSelecionado.nomeFuncionario,
                id: this.horarioFlexivelSelecionado.idFuncionario,
                pis: this.horarioFlexivelSelecionado.pisFuncionario,
            }
            let hrFlex = {...this.horarioFlexivelSelecionado};
            hrFlex.dia = this.formatarData(hrFlex.dia);
            let requisicao = {  
                cnpj: cnpjSelecionado,
                funcionario: funcionario,
                horarioFlexivel: {...this.horarioFlexivelSelecionado},
                usuarioRequisicao: {...this.getDadosRequisicao()}
            };	
			this.mudancaHorarioService.excluir(requisicao)
            .then(resp => {             
                if(resp.data instanceof Array) {
                    exibirMensagemSis(this, 'Sucesso', false);     
                } else {
                    exibirMensagem(this, resp);   
                }                         
                this.limparExcluir();
                this.listar();
                if(resp.data instanceof Array && resp.data.length > 0) {
                    let novaRequisicao = {
                        mes: resp.data[0].mes,
                        ano: resp.data[0].ano,
                        dataInicio: resp.data[0].dataInicio,
                        dataFinal: resp.data[0].dataFinal,
                        cnpj: cnpjSelecionado,
                        funcionario:  {
                            id: funcionario.id,
                            nome: funcionario.nome,
                            pis: funcionario.pis
                        },      
                        usuarioRequisicao: {...this.getDadosRequisicao()},          
                    };
                    this.calcularPeriodoEditado(novaRequisicao);
                }
            })
            .catch(erro => {exibirMensagem(this, erro)}); 
        },
        /**
         * 
         */
         calcularPeriodoEditado(requisicao) {           
            this.controlePontoService.calcularPeriodoEditado2(requisicao)
            .then()
            .catch(erro => {exibirMensagem(this, erro)}); 
        },
        /**
         * 
         */
        listar() {
            if(this.idCnpjSelecionado == null) {
                exibirMensagemSis(this, 'Selecione uma empresa', true);
                return;
            }
            let idsCentrosCustos = [];
            if(this.idCentroCustoSelecionado == null) {               
                this.centrosCustos.forEach(ctc => {
                    if(ctc.id != null) {
                        idsCentrosCustos.push(ctc.id);
                    }
                });
            } else {
                idsCentrosCustos.push(this.idCentroCustoSelecionado);
                this.filtrarCentosCustosFilhos(this.idCentroCustoSelecionado, this.centrosCustos, idsCentrosCustos);
            }            
            let requisicao = {  
                idsCentrosCustos: idsCentrosCustos,            
                dataInicio: this.formatarData(this.dataInicio),
                dataFinal: this.formatarData(this.dataFinal),
                usuarioRequisicao: {...this.getDadosRequisicao()}
            };	
			this.mudancaHorarioService.listar(requisicao)
				.then(resp => {                    
                    this.horarios = resp.data;           
                })
                .catch(erro => {exibirMensagem(this, erro)}); 
        },
        /**
         * 
         */
        editar(horarioFlexivel) {		
			let requisicao = {
				idHorarioFlexivel: horarioFlexivel.id,
				usuarioRequisicao: {...this.getDadosRequisicao()}
			}	
			this.mudancaHorarioService.buscar(requisicao)
				.then(resp => {	
                    this.horarioFlexivelEditar = resp.data.horarioFlexivel;    
                    this.horarioFlexivelEditar.dia = this.formatarStringData(this.horarioFlexivelEditar.dia);
                    this.funcionario = resp.data.funcionario;                    
                    this.idJustificativaSelecionada = resp.data.justificativa.id;
                    this.justificativas = resp.data.justificativas;
					this.exibirDialogEditar = true;				
				})
				.catch(erro => {exibirMensagem(this, erro)});
		},
        /**
         * 
         */
        filtrarCentosCustosFilhos(idCentroCustoPrincipal, centrosCustos, idsCentrosCustos) {
            centrosCustos.forEach(ct => {
                if(ct.id != null 
                    && ct.centroCustoPaiId
                    && ct.centroCustoPaiId == idCentroCustoPrincipal) {
                    idsCentrosCustos.push(ct.id);
                    this.filtrarCentosCustosFilhos(ct.id, centrosCustos, idsCentrosCustos);
                }
            }); 
        },
        /**
         * 
         */
		confirmarExcluir(horarioFlexivel) {
			this.horarioFlexivelSelecionado = horarioFlexivel;
			this.exibirDialogConfirmarExcluir = true;
		},
        /**
         * 
         */
		limparExcluir() {
			this.horarioFlexivelSelecionado = {id: null, nomeFuncionario: '', data: null};
			this.exibirDialogConfirmarExcluir = false;
		},
        /**
         * 
         */
		fecharModal() {
            this.horarioFlexivelEditar = new HorarioFlexivel();
			this.exibirDialogEditar = false;
		},
        /**
         * 
         */
        listarCnpjs() {
            if(this.cnpjs.length > 0) {
                return;
            }
            // Cache dados
            let cacheEmpresa = this.getCacheEmpresa();
            this.cnpjs = cacheEmpresa.cnpjs;
            this.centrosCustos = [];  
            let centroCusto = new CentroCusto();
            centroCusto.nome = 'Todos';
            centroCusto['keyRefId'] = Date.now();
            this.centrosCustos.push(centroCusto);
            Array.prototype.push.apply(this.centrosCustos, [...cacheEmpresa.centrosCustos]);     
            if(cacheEmpresa.idCnpjSelecionado) {
                this.idCnpjSelecionado = cacheEmpresa.idCnpjSelecionado;
            }
        },
        /**
         * 
         */
        listarCentrosCustos() {
            let requisicao = {
                idCnpj: this.idCnpjSelecionado,
                usuarioRequisicao: {...this.getDadosRequisicao()}
            };
            this.centroCustoService.listarCentrosCustosUsuario(requisicao)
            .then(resp => {            
                let dataKey = 1;               
                resp.data.forEach(ct => {
                    ct['keyRefId'] = dataKey++;
                });           
                this.idContratoSelecionado = null;                     
                this.centrosCustos = []; 
                let centroCusto = new CentroCusto();
                centroCusto.nome = 'Todos';
                centroCusto['keyRefId'] = Date.now();
                this.centrosCustos.push(centroCusto);
                Array.prototype.push.apply(this.centrosCustos, resp.data);                    
            })
            .catch(erro => {exibirMensagem(this, erro)});
        },
        /**
         * 
         */
        formatarData(data) {
			if(!data) {
				return null;
			}
			let strData = null;
			if(data instanceof Date) {
				let dt = data;
				let mes = dt.getMonth();
				let dia = dt.getDate();
				strData = dt.getFullYear() + '-' + ((mes + 1) < 10 ? '0'+(mes+1) : ''+(mes+1)) + '-' + (dia < 10 ? '0' + dia : '' + dia);
			} else {
				let partes = data.split('/');
				strData = partes[2] + '-' + partes[1] + '-' + partes[0];
			}
			return strData;
		},
        /**
         * 
         */
        formatarStringData(data) {
			let partes = data.split('-');
			return partes[2] + '/' + partes[1] + '/' + partes[0];
		},
        /**
         * 
         */
        limparEntradaHoraInvalida(campo) {
            if(this.horarioFlexivelEditar[campo] == null) {
                return;
            }
            let regex = /[0-2][0-9]:[0-5][0-9]/g;
            if(!this.horarioFlexivelEditar[campo].match(regex)) {
                this.horarioFlexivelEditar[campo] = '';
            }
        },
        /**
         * 
         */
        validarEntraHora(event) {
            formatarEtradaHora(event);
        },
        /**
         * 
         */
        validarPermissoes() {		
			let permissoes = this.getPermissoes();
			this.permissaoEditar = permissoes.includes(117);
			this.permissaoExcluir = permissoes.includes(118);				
		}
    },
    created() {
        this.controlePontoService = new ControlePontoService();
        this.mudancaHorarioService = new MudancaHorarioService();
        this.centroCustoService = new CentroCustoService();       
    },
    mounted() {
        this.listarCnpjs();
        this.validarPermissoes();
    }
}
</script>

<style>

</style>